import { AlertType, CreateAlertDTO, AlertOperation, AlertAction } from '@meshwatch/types';
import * as Yup from 'yup';

import { typeErrorHandler, validate } from '../../shared/validation';
import { userIdSchema } from '../../shared/validation/schemas';
import { ValidationResponse } from '../../shared/validation/types';

const alertTypeErrorHandler = (params: Partial<Yup.TestMessageParams>): string => {
  return typeErrorHandler('Alert', params);
};

const CREATE_ALERT_SCHEMA_OBJECT = {
  userId: userIdSchema,
  monitorId: Yup.string().required('monitorId is required'),
  actionValue: Yup.string().required('actionValue is required'),
  value: Yup.number().required('value is required'),
  windowDuration: Yup.number().required('windowDuration is required'),
  type: Yup.string()
    .oneOf(['downtime'])
    .required('Alert type is required') as Yup.Schema<AlertType>,
  operation: Yup.string()
    .oneOf(['gt', 'lt'])
    .required('Alert operation is required') as Yup.Schema<AlertOperation>,
  action: Yup.string()
    .oneOf(['email', 'webhook'])
    .required('Alert action is required') as Yup.Schema<AlertAction>,
};

const CREATE_ALERT_SCHEMA = Yup.object()
  .shape(CREATE_ALERT_SCHEMA_OBJECT)
  .typeError(alertTypeErrorHandler);

export function validateCreateAlertPayload(
  payload: CreateAlertDTO
): Promise<ValidationResponse<CreateAlertDTO>> {
  return validate<CreateAlertDTO>(CREATE_ALERT_SCHEMA, payload);
}
